export default "__VITE_ASSET__mU9Zxh02__"